// @flow

export class HTTPError extends Error {
  response: Response;

  constructor(response: Response) {
    super(`Encountered HTTP error code ${response.status}`);
    // eslint-disable-next-line fp/no-mutation
    this.name = 'HTTPError';
    // eslint-disable-next-line fp/no-mutation
    this.response = response;
  }
}
